import { useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import { financeAgingSchema } from "../../../shared/account-finance/finance-aging-contract";
import type { FinanceAging } from "../../../shared/account-finance/finance-aging-contract";

export function useFinanceAgingWorkspace(reportId: string, code: string) {
  const [requested, setRequested] = useState(false);
  const [data, setData] = useState<FinanceAging | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    if (!requested) return () => controller.abort();
    setLoading(true); setError(null);
    void apiRequest<unknown>(`/api/account-finance/reports/${reportId}/aging/${code}`, {
      signal: AbortSignal.any([controller.signal, AbortSignal.timeout(10_000)]),
    }).then((raw) => { if (!controller.signal.aborted) setData(financeAgingSchema.parse(raw)); })
      .catch((failure: unknown) => { if (!controller.signal.aborted) setError(failure instanceof Error ? failure.message : "Kapama detayı alınamadı."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [requested, reportId, code]);
  return { requested, open: () => setRequested(true), data, error, loading };
}
